import { lazy, Suspense } from 'react';
import { motion } from 'framer-motion';
import PageNavbar from '../../components/feature/PageNavbar';
import Footer from '../home/components/Footer';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import {
  useSEO,
  generateWebPageSchema,
  generateContactPageSchema,
  generateBreadcrumbSchema,
} from '../../utils/seo';

const ContactInfoBento = lazy(() => import('./components/ContactInfoBento'));

const SectionLoader = () => (
  <div className="py-16 flex items-center justify-center">
    <div className="w-8 h-8 border-4 border-brand-green border-t-transparent rounded-full animate-spin" />
  </div>
);

export default function ContactPage() {
  useSEO({
    title: 'Kontakt - Webdesign Titisee-Neustadt 79822 | Benjamin Reick',
    description:
      'Kontakt zu Benjamin Reick – Webdesign Titisee-Neustadt. Tel: +49 162 3651571 | info-aiagents@web.de. Kostenlose Beratung im Schwarzwald.',
    keywords:
      'Webdesign Kontakt Titisee-Neustadt, Webdesigner 79822 kontaktieren, Webdesign Anfrage Schwarzwald',
    canonical: '/contact',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateWebPageSchema('Kontakt - Jetzt Webdesign-Projekt starten', 'Kontaktieren Sie uns für Ihr Webdesign-Projekt', '/contact'),
        generateContactPageSchema(),
        generateBreadcrumbSchema([
          { name: 'Startseite', url: '/' },
          { name: 'Kontakt', url: '/contact' },
        ]),
      ],
    },
  });

  return (
    <div className="min-h-screen bg-white">
      <PageNavbar />
      <section className="relative pt-40 pb-20 overflow-hidden">
        <div className="absolute inset-0" aria-hidden="true">
          <div className="absolute top-20 left-10 w-64 h-64 bg-gradient-to-br from-brand-beige/40 to-brand-brown/20 rounded-full blur-3xl"></div>
          <div className="absolute top-40 right-20 w-96 h-96 bg-gradient-to-br from-brand-green/20 to-brand-beige/30 rounded-full blur-3xl"></div>
        </div>
        <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1 className="text-6xl md:text-7xl font-caprasimo mb-6 text-brand-black">Kontakt aufnehmen</h1>
            <p className="text-xl text-brand-grey max-w-3xl mx-auto">
              Lassen Sie uns über Ihr Projekt sprechen. Ich melde mich innerhalb von 24 Stunden bei Ihnen.
            </p>
          </motion.div>
        </div>
      </section>
      <Suspense fallback={<SectionLoader />}>
        <ContactInfoBento />
      </Suspense>
      <Footer />
      <ScrollToTopButton />
    </div>
  );
}
